const APPLE_PAY_VERSION_NUMBER = 3;
const merchantIdentifier = process.env.REACT_APP_APPLE_PAY_MERCHANT_ID;

const CURRENCY_CODE = 'KZT';

const ApplePayButtonStatus = { UNKNOWN: 0, AVAILABLE: 1, NOT_AVAILABLE: 2 };
const PaymentStatusApplePay = { SUCCESS: 0, FAILURE: 1, CANCEL: 2 };

export {
  merchantIdentifier,
  APPLE_PAY_VERSION_NUMBER,
  CURRENCY_CODE,
  ApplePayButtonStatus,
  PaymentStatusApplePay,
};
